export default __webpack_public_path__ + "static/media/LoaderIcon2.fc8fb465.svg";